import comp from "./ShortcutSettingsPage";
export default comp;
